import { getRealmFromSubDomain } from '../services/oidc.service'

export function getRealmId() {
  return getRealmFromSubDomain() ?? localStorage.getItem('realmId')
}

export function shouldShowMovedMessage() {
  return getRealmFromSubDomain() === null && !localStorage.getItem('internalZynkaUser')
}
